import { ProjectType } from "@/consts/Project";
import { create } from "zustand";

interface SelectedProjectInfo {
  projectId: string;
  projectType: ProjectType;
  originalId: string;
  latestSheetId: string;
}

interface TabState {
  selectedProjectInfo: SelectedProjectInfo | null;
  setSelectedProjectInfo: (info: Partial<SelectedProjectInfo>) => void;
  resetSelectedProjectInfo: () => void;
}

const useTabStore = create<TabState>((set) => ({
  selectedProjectInfo: null,
  setSelectedProjectInfo: (info) =>
    set((state) => ({
      selectedProjectInfo: state.selectedProjectInfo
        ? { ...state.selectedProjectInfo, ...info }
        : (info as SelectedProjectInfo),
    })),
  resetSelectedProjectInfo: () => set({ selectedProjectInfo: null }),
}));

export function useSelectedProjectInfo() {
  return useTabStore((state) => state.selectedProjectInfo);
}

export function useSetSelectedOriginalInfo() {
  return useTabStore((state) => state.setSelectedProjectInfo);
}

export function useResetSelectedProjectInfo() {
  return useTabStore((state) => state.resetSelectedProjectInfo);
}
